import { collections } from "@/mocks/homeContent";
import { useReveal } from "@/hooks/useReveal";

export default function CuratedCollections() {
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  return (
    <section id="collections" className="w-full bg-background-50 py-14 md:py-20">
      <div
        ref={ref}
        className={`mx-auto w-full px-4 md:px-8 ${visible ? "reveal is-visible" : "reveal"}`}
      >
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-4 w-1 rounded-full bg-primary-500" />
              <span className="text-xs font-medium tracking-[0.18em] text-secondary-600">
                CURATED COLLECTIONS
              </span>
            </div>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              精选专题合集
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              把零散更新整理成成套的专题合集，按主题一路读下来，比逐条翻阅更容易建立完整认知。
            </p>
          </div>
          <a
            href="#latest"
            className="flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            浏览全部合集
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:gap-6">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-400 sm:flex-row"
            >
              <div className="relative h-[200px] w-full shrink-0 overflow-hidden sm:h-auto sm:w-[220px]">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 黑料福利精选专题合集`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-stack-line" /> {item.count}
                  </span>
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">
                    合集
                  </span>
                </div>
                <h3 className="font-heading mt-3 text-lg font-semibold text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.subtitle}</p>
                <div className="mt-auto flex flex-wrap items-center gap-2 pt-4">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800"
                    >
                      #{tag}
                    </span>
                  ))}
                  <a
                    href="#latest"
                    className="ml-auto flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-transform group-hover:translate-x-0.5"
                  >
                    查看合集
                    <i className="ri-arrow-right-s-line" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}